import { PromoModalItem, PromoModalOffer, PromoModalTitle } from "./elements";
import PromoModalPage from "./PromoModalPage";
import PromoModalPageProduct from "./PromoModalPageProduct";

export {
    PromoModalItem,
    PromoModalOffer,
    PromoModalTitle,
    PromoModalPage,
    PromoModalPageProduct,
};



// WEBPACK FOOTER //
// src/client/components/site/features/promos/index.js